import getApiClient from '@/plugins/api-client'
import { formatDate } from '@/util/helpers'
import Vue from 'vue'

export default {
  loadCoupon () {
    const api = getApiClient(this.$store)
    const couponId = this.$route.params.id

    api.get(`discount_coupons/${couponId}`)
      .then(result => {
        this.coupon = result.data
        if (this.coupon.validFrom) {
          this.formattedValidFrom = formatDate(new Date(this.coupon.validFrom))
        }

        if (this.coupon.validUntil) {
          this.formattedValidUntil = formatDate(new Date(this.coupon.validUntil))
        }
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const method = this.coupon['@id'] ? 'patch' : 'post'
    const options = {}

    let endpoint = 'discount_coupons'

    if (method === 'patch') {
      options.headers = {
        'Content-Type': 'application/merge-patch+json',
      }
      endpoint = this.coupon['@id']
    }

    api[method](endpoint, this.coupon, options)
      .then(result => {
        this.user = result.data
        this.$store.commit('app/raiseSuccess', 'Cupom salvo com sucesso')
        this.$router.push({
          name: 'DiscountCoupons',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar cupom')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },

  setDate (property, value) {
    const regex = /([\d]{2})\/([\d]{2})\/([\d]{4}) ([\d]{2}):([\d]{2})/
    const [day, month, year, hours, minutes] = value.split(regex).filter(value => value)

    return new Date(year, month - 1, day, hours, minutes)
  },

  searchStudents (query) {
    const api = getApiClient(this.$store)

    const params = {
      email: query,
      roles: ['ROLE_STUDENT'],
    }

    api.get('users', { params })
      .then(result => {
        this.studentsList = result.data['hydra:member']
      })
      .catch(() => {
        return false
      })
  },

  validateCouponDate (value) {
    if (value) {
      const regex = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/
      if (!value.match(regex)) {
        return ['Preencha a data e hora completa (ex. 10/10/2022 00:00']
      }
    }
  },
}
